import React from 'react';
import {inject,observer} from 'mobx-react';
import {toJS} from 'mobx';
import './index.scss';

import CircularProgress from '@material-ui/core/CircularProgress';

import Icon from '@mdi/react'
import { mdiPlus} from '@mdi/js'

import CustomTable from '../../../components/complex/customTable'
import Search from '../../../components/basic/search';
import CustomButton from '../../../components/basic/CustomButton'
import CustomSnackbar from '../../../components/global/snackbar'
import CreateNewClient from '../../clients/create'
import ImportClients from './import';

import {api} from '../../../functions/api'
import DeleteDialog from '../../../components/global/deleteDialog';

import queryString from 'query-string'
import { debounce } from 'lodash'

const TIMEOUT = 3000;


@inject('internal')
@inject('translate')
@observer
export default class ClientsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
            createNewClient: false,
            searchTerm: "",
            import: false, //dialog window for import clients
        }
    }

    componentDidMount() {
        this.loadClients();
        this.props.internal.setRoute(this.props.history, this.props.location.pathname)
        this.setPermissions();

        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)

        let searchTerm;
        if(queries.searchterm) {
            searchTerm = queries.searchterm;
            this.setState({searchTerm: searchTerm})
        }
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    loadClients = async (size = 10, page = 0, searchterm = "", by = "name", dir = "asc") => {
    
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString);

        if(queries) {
            
            if(queries.page_number) {
                page = queries.page_number
            }

            if(queries.page_size) {
                size = queries.page_size
            }

            if(queries.by) {
                by = queries.by
            }

            if(queries.dir) {
                dir = queries.dir
            }

            if(queries.searchterm) {
                searchterm = queries.searchterm
            }
        }
        
        let load_data = await api({
            method: 'get',
            url: 'clients',
            authorization: this.props.internal.user.access_token,
            params: {
                searchterm: searchterm,
                page:{
                    number: page,
                    size: size,
                },
                order: [
                    {
                        by: by,
                        dir: dir
                    }
                ]
            }
        })

        if (load_data.success === true) {
            if (load_data.data) {

                this.props.internal.setDataForTable(load_data.data)
                //this.changeUrl()
                // this.setPermissions();
            }
        }
        this.setState({
            loading: false
        }, () => {

        })
    }

    handleChangeRowsPerPage = (size) => {
        this.setState({
            loading: true
        });
        this.addQueryToUrl("page_size", size)
    }

    handleChangePage = (page) => {
        this.setState({
            loading: true
        });

        this.addQueryToUrl("page_number", page + 1)
    }

    handleSearch = debounce((searchTerm) => {
        if (searchTerm.length > 2) {
            this.addQueryToUrl("searchterm", searchTerm)
        }
        else  {
            this.addQueryToUrl("searchterm", "")
        }
    }, 500)

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl("dir", dir,"by", orderBy)
    }

    addQueryToUrl = (param, value, param2 = null, value2 = null) => {
        const URLqueryString = this.props.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value
        if(param2 && value2) {
            queries[param2] = value2
        }

        let new_path = this.props.location.pathname

        new_path += "?"
        for(let key in queries) {
            if(key) {
                new_path += key + "=" + queries[key] + "&"
            }
        }
        new_path = new_path.slice(0,-1)

        this.props.internal.pushRoute(new_path)
        this.loadClients()
    }

    handleCloseSnackbar = () => {
        this.setState({
            message: "",
            openSnackbar: false
        })
    };


    handleOpenCreateNewClient = () => {
        this.setState({
            createNewClient: true
        });
    }

    handleCloseCreateNewClient = () => {
        this.setState({
            createNewClient: false
        });
    }

    handleDeleteClient = () => {

        this.props.internal.setActionDelete();
        this.deleteClient(this.props.internal.actionDeleteObj.id)
    }

    deleteClient = async (idClient) => {
        this.setState({
            loading: true
        })
        let delete_data = await api({
            method: 'delete',
            url: 'clients/' + idClient,
            authorization: this.props.internal.user.access_token,
        })

        if (delete_data.success && delete_data.success === true) {
            this.setState({
                message: delete_data.data.message,
                openSnackbar: true,
            })
            let tmpSize = Number(toJS(this.props.internal.dataForTable.meta.per_page));
            let tmpPage = Number(toJS(this.props.internal.dataForTable.meta.current_page))
            this.loadClients(tmpSize, tmpPage, "")
            this.turnOffSnackBar();
        } else {

            this.setState({
                message: delete_data.data.message,
                openSnackbar: true
            })
            this.turnOffSnackBar();
        }
        this.setState({
            loading: false
        })
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({
                message: "",
                openSnackbar: false
            })
        }, TIMEOUT)
    }

    tableHeader = [{
            "title": "name",
            "numeric": false,
            "min_width": "100px"
        },
        {
            "title": "id_no",
            "numeric": false
        },
        // {
        //     "title": "rabat_level",
        //     "numeric": true
        // },
        // {
        //     "title": "orders",
        //     "numeric": true,
        //     sortBy: "orders_count"
        // },
        // {
        //     "title": "users",
        //     "numeric": true,
        //     sortBy: "users_count"
        // },
        // {
        //     "title": "docs",
        //     "numeric": true,
        //     sortBy: "documents_count"
        // },
        // {
        //     "title": "representatives",
        //     "numeric": true,
        //     sortBy: "admins_count"
        // }
    ];
    tableBody = [
        "name",
        "id_no",
        // "rabat_level",
        // "orders_count",
        // "users_count",
        // "documents_count",
        // "admins_count"
    ]

    setPermissions() {
        let permissions = toJS(this.props.internal.user.data.permissions.clients);

        if(permissions.destroy) {
            this.dropDownMenuItems.push(
                {
                    title: this.props.translate.i18n.MODULES.CLIENTS.MENU_ITEMS.DELETE,
                    action: "delete"
                }
            )
        }

        let role_id = toJS(this.props.internal.user.data.role.id)
        if(role_id < 3 || role_id > 4 ) {
            this.tableHeader.push({
                "title": "rabat_level",
                "numeric": true
            })

            this.tableBody.push("rabat_level")
        }

        this.tableHeader.push(
            {
                "title": "orders",
                "numeric": true,
                sortBy: "orders_count"
            },
            {
                "title": "users",
                "numeric": true,
                sortBy: "users_count"
            },
            {
                "title": "docs",
                "numeric": true,
                sortBy: "documents_count"
            },
            {
                "title": "representatives",
                "numeric": true,
                sortBy: "admins_count"
            }
        )

        this.tableBody.push(
            "orders_count",
            "users_count",
            "documents_count",
            "admins_count")
        
    }

    dropDownMenuItems = [{
            title: this.props.translate.i18n.MODULES.CLIENTS.MENU_ITEMS.DETAIL,
            // url: "detail/tab=0"
            url: "basic"
            //action: "edit"
        },
        // {
        //     title: this.props.translate.i18n.MODULES.CLIENTS.MENU_ITEMS.DELETE,
        //     //url: "delete",
        //     action: "delete"
        // }
    ]

    handleCloseEditClient = () => {
        let data = {
            edit: false,
            id: null
        }
        this.props.internal.setActionEdit(data);
    }

    showSnackbar = (message, open) => {
        this.setState({message: message, openSnackbar: open, createNewClient: false})
        this.turnOffSnackBar();
        this.loadClients();
    }

    handleImportClients = () => {
        this.setState({import: !this.state.import})
    }

    render() {

        const routerData = {
            history: this.props.history,
            location: this.props.location,
            match: this.props.match
        }

        let permissions = toJS(this.props.internal.user.data.permissions.clients);

        return ( < div className = {
                'clients-container'
            } >
            <CustomSnackbar message = {
                this.state.message}
                open = {this.state.openSnackbar}
            />
            <DeleteDialog
                open = {this.props.internal.actionDelete}
                title = {this.props.translate.i18n.MODULES.CLIENTS.DELETE_CLIENT_TITLE}
                content = {this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                btn_cancel = {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                btn_delete = {this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                delete = {this.handleDeleteClient }
            />

            {this.state.import ?
                <ImportClients
                    open = {this.state.import}
                    title={this.props.translate.i18n.MODULES.CLIENTS.IMPORT_CLIENTS_DIALOG_TITLE}
                    onClose={this.handleImportClients}
                />
                :
                null
            }

            {this.state.createNewClient ?
                    <CreateNewClient
                        routerData = {routerData}
                        open = {this.state.createNewClient}
                        close = {this.handleCloseCreateNewClient}
                        title = {this.props.translate.i18n.MODULES.CLIENTS.CREATE_NEW_CLINET.TITLE}
                        showSnackbar={this.showSnackbar}
                        //reload = {this.loadClients}
                    />
                    :
                null
            }
            {this.state.loading ?
                    null :

                    <div className = {'flex space-between '} >
                    <Search
                        value = { this.state.searchTerm ? this.state.searchTerm : ""}
                        placeholder = {this.props.translate.i18n.MODULES.CLIENTS.SEARCH}
                        classes = {'clients-search-box '}
                        onChange = {this.handleSearch}
                        />
                    <div className = {'clients-buttons'} >
                    {permissions.store ?
                        <div >
                        <CustomButton
                            mystyle = {'btn-orange-bg border-radius-18'}
                            title = {this.props.translate.i18n.MODULES.CLIENTS.CREATE_NEW_CLIENT}
                            onClick = {this.handleOpenCreateNewClient} >
                                <Icon path = {mdiPlus}
                            size = {1 }
                            />
                        </CustomButton>

                        {/* <CustomButton
                        style = {'btn-boulder-bg border-radius-18'}
                        title = { this.props.translate.i18n.GLOBAL.TABLE.UPLOAD}
                        onClick={this.handleImportClients}
                        >
                        < Icon path = { mdiUpload}
                            size = {1}
                        />
                        </CustomButton>  */}
                        </div> :
                            null
                    }
                    </div>
                    </div>
            } {
                this.state.loading ?
                    <CircularProgress className = {'circular-progress'}/>
                    :
                    <CustomTable
                    dropDownMenuItems = {this.dropDownMenuItems}
                    module = {'/clients'}
                    handleChangeRowsPerPage = {this.handleChangeRowsPerPage}
                    handleChangePage = {this.handleChangePage}
                    handleSort = {this.handleSort}
                    header = {this.tableHeader}
                    body = {this.tableBody}

                />
            }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/list/index.js